import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TitleService implements OnDestroy {
  private translationSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private title: Title
  ) {
    this.initializeTitle();
  }

  private initializeTitle(): void {
    // Suscribirse a cambios de idioma
    this.translationSubscription = this.translate.onLangChange.subscribe(() => {
      this.updateTitle();
      this.updateHtmlLang();
    });

    // Actualizar título inicial
    this.updateTitle();
    this.updateHtmlLang();
  }

  private updateTitle(): void {
    this.translate.get('COMMON.APP_TITLE').subscribe(translatedTitle => {
      this.title.setTitle(translatedTitle);
    });
  }

  private updateHtmlLang(): void {
    const currentLang = this.translate.currentLang;
    if (currentLang) {
      document.documentElement.lang = currentLang;
    }
  }

  ngOnDestroy(): void {
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
  }
}
